export type PaymentStateType = 'AUTHORIZATION_HOLD' | 'AWAITING_AUTHORIZATION' | 'CANCELED' | 'COMPLETED' | 'INITIATED' | 'REJECTED' | 'REFUNDED' | 'REFUND_REJECTED' | 'REFUND_INITIATED';
export type BillingType = 'CHARGE' | 'FEE' | 'REFUND' | 'PRE_PAYMENT';
export type Currency = 'AUD' | 'CAD' | 'CNY' | 'CZK' | 'EUR' | 'JPY' | 'GBP' | 'CHF' | 'USD';
export interface Amount {
    amount?: number;
    currency?: Currency;
    /**
     * Gross value of the amount.
     */
    grossAmount?: number;
}

export interface ErrorsItem {
    /**
     * Error code
     * example:
     * BAD_REQUEST
     */
    code?: string;
    /**
     * Error code message
     * example:
     * Bad Request
     */
    message?: string;
    /**
     * Error code details
     * example:
     * Details of Bad request response
     */
    details?: string;
    /**
     * Last update datetime.
     * example:
     * 2017-11-22T17:56:44.000Z
     */
    timestamp?: string; // ^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])(T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9]).([0-9][0-9][0-9])Z)$
}

export interface TripBilling {
    /**
     * URL to fetch the invoice PDF as defined in the MSP system.
     * example:
     * https://api.app.miles-mobility.com/mobile/Invoice?invoiceUUID=24120A9A-E442-4C27-BDE8-6F84FF03E6D7?asPDF=1
     */
    invoicePDFURL?: string;
    /**
     * The invoice number generated by the MSP
     */
    invoiceNumber?: string;
    totalAmount?: /* Object representing Amount type in BUS model */ Amount;
    refundAmount?: /* Object representing Amount type in BUS model */ Amount;
    state?: /**
             * The state of the payment.
             * example:
             * AWAITING_AUTHORIZATION
             */
    PaymentStateType;
    type: /**
             * Type of the billing entry.
             * example:
             * CHARGE
             */
    BillingType;
    /**
     * Last update datetime.
     * example:
     * 2017-11-22T17:56:44.000Z
     */
    timestamp: string; // ^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])(T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9]).([0-9][0-9][0-9])Z)$
    paymentId: string;
}

export interface GetTripPaymentResponse {
    /**
     * ID of a user.
     * example:
     * 59549a90-849e-472a-aae2-b13331d342e7
     */
    customerId: string;
    /**
     * Id of the Service Provider.
     * example:
     * Miles
     */
    serviceProviderId: string;
    /**
     * ServiceProvider MSP Trip Id
     * example:
     * 59549a90-849e-472a-aae2-b13331d342e7
     */
    serviceProviderTripId?: string;
    /**
     * STM MSP Trip Id
     * example:
     * 59549a90-849e-472a-aae2-b13331d342e7
     */
    referenceId: string;
    billings?: TripBilling[];
    errors?: ErrorsItem[];
    /**
            * Timestamp when trip started.
            * example:
            * 2017-11-22T17:56:44.000Z
            */
    createdAt: string; // ^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])(T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9]).([0-9][0-9][0-9])Z)$
    /**
     * Timestamp when trip ended.
     * example:
     * 2017-11-22T17:56:44.000Z
     */
    updatedAt?: string; // ^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])(T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9]).([0-9][0-9][0-9])Z)$

    totalAmount: {
        currency: 'EUR',
        grossAmount: number
    }

    refundAmount: {
        currency: 'EUR',
        grossAmount: number
    }

    invoiceAmount: {
        currency: 'EUR',
        grossAmount: number
    }

    state: BillingEntryState
    paymentId: string;
}

export type BillingEntryState = 'PAID' | 'UNPAID' | 'PARTIAL_UNPAID' | 'FULLY_UNPAID' | 'PREAUTH' | 'REFUND_INITIATED' | 'REFUNDED' | 'REFUND_REJECTED';

export const TripServiceProvider = {
    MILES: 'Miles',
    EMULATOR: 'MSP_Emulator',
    DOTT: 'Dott',
    EUROPCAR: 'Europcar',
}

export const TripServiceProviderKeys = Object.keys(TripServiceProvider);

export type FilterTripServiceProviderTypes = keyof (typeof TripServiceProvider) | null;